module.exports = __webpack_public_path__ + "static/img/blnk_img.3b065d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/en/images/blnk_img.png
// module id = 9FNR
// module chunks = 25